// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TAEC","textarea":"styles_textarea__2P4K6"};